"use strict";

var _interopRequireDefault = require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.object.keys");
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/web.dom.iterable");
var _api = require("../../api/api");
var _login = _interopRequireDefault(require("../../components/loginreg/login"));
var _cookie = require("@/assets/static/js/utils/cookie.js");
var _sideNav = _interopRequireDefault(require("../../components/side-nav.vue"));
var _footNav = _interopRequireDefault(require("../../components/foot-nav"));
var _topNav = _interopRequireDefault(require("@/components/top-nav.vue"));
var _default = exports.default = {
  name: "home",
  components: {
    sideNav: _sideNav.default,
    footNav: _footNav.default,
    topNav: _topNav.default
  },
  data: function data() {
    return {
      sectionAnimations: {
        cont01: false,
        cont02: false,
        cont03: false,
        cont04: false,
        cont05: false
      },
      dataBoardAnimated: false,
      // 数据看板动画状态
      // 数据看板
      dataBoard: {
        huoyuan: {
          value: 0,
          target: 12634,
          unit: '万条'
        },
        huozhu: {
          value: 0,
          target: 300000,
          unit: '个'
        },
        rjhuoyuan: {
          value: 0,
          target: 160000,
          unit: '票'
        },
        che: {
          value: 0,
          target: 1381,
          unit: '万条'
        },
        siji: {
          value: 0,
          target: 180000,
          unit: '个'
        },
        onlineCar: {
          value: 0,
          target: 40000,
          unit: '辆'
        }
      },
      currentIndex: 0,
      // 存放中间区域的图片列表
      middleImages: ['https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E9%A6%96%E9%A1%B5/%E6%99%BA%E8%83%BD%E5%8C%B9%E9%85%8D-%E6%95%B0%E6%8D%AE%402x.png', 'https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E9%A6%96%E9%A1%B5/-h-%E5%AE%89%E5%85%A8%E4%BF%9D%E9%9A%9C%E6%A6%82%E5%BF%B5%E5%9B%BE.png', 'https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E9%A6%96%E9%A1%B5/-h-%E5%B9%B3%E5%8F%B0%E6%92%AE%E5%90%88%E6%A6%82%E5%BF%B5%E5%9B%BE.png', 'https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E9%A6%96%E9%A1%B5/-h-%E6%99%BA%E8%83%BD%E5%8C%B9%E9%85%8D-%E8%AF%B4%E6%98%8E.png'],
      // 背景图列表
      backgroundImages: ['https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E9%A6%96%E9%A1%B5/-h-%E6%99%BA%E8%83%BD%E5%8C%B9%E9%85%8Dbg.png', 'https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E9%A6%96%E9%A1%B5/-h-%E5%AE%89%E5%85%A8%E4%BF%9D%E9%9A%9C-bg.png', 'https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E9%A6%96%E9%A1%B5/-h-%E5%B9%B3%E5%8F%B0%E6%92%AE%E5%90%88bg.png', 'https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E9%A6%96%E9%A1%B5/-h-%E6%99%BA%E8%83%BD%E5%8C%B9%E9%85%8Dbg.png'],
      // cont-03 Tab 数据
      dataBoardTabs: [{
        title: 'TMS',
        subtitle: '危险品物流管理系统',
        image: 'https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E9%A6%96%E9%A1%B5/-h-TMS.png'
      }, {
        title: 'WMS',
        subtitle: '危险品仓储管理系统',
        image: 'https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E9%A6%96%E9%A1%B5/-h-WMS.png'
      }, {
        title: 'BMS',
        subtitle: '化工园区智慧管理系统',
        image: 'https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E9%A6%96%E9%A1%B5/-h-BMS.png'
      }, {
        title: '镖神管家',
        subtitle: '企业AI SAASA数智管理系统',
        image: 'https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E9%A6%96%E9%A1%B5/-h-%E9%95%96%E7%A5%9E%E7%AE%A1%E5%AE%B6.png'
      }],
      activeTabIndex: 0,
      hoverTabIndex: null,
      // 悬停预览的 tab 索引
      // 左右两侧文字
      sideTexts: [{
        left: '智慧塔多层算法模型',
        right: '智慧塔多层算法模型'
      }, {
        left: '平台撮合',
        right: '平台撮合'
      }, {
        left: '安全保障',
        right: '安全保障'
      }, {
        left: '大数据智能匹配',
        right: '大数据智能匹配'
      }],
      // 轮播图底部的文案配置
      dataBoardBottomTexts: [{
        title: '智能匹配',
        content: ['货源运力数字化', '大数据智能匹配'],
        desc: ['平台拥有20万符合危化品运输资质要求的认证运力', '借助大数据、智能配载系统，实现货主与运力智能精准匹配']
      }, {
        title: '安全保障',
        content: ['双向认证多维保障', '缔造安全交易场景'],
        desc: ['采用货主/车主实名认证，提供货损、加价、延误、资金安全等双向保障，', '构建全新的安全交易场景，保障企业用户财务、运输、车辆、调度']
      }, {
        title: '平台撮合',
        content: ['高效畅通车货匹配全程', '守护车货双方自由撮合'],
        desc: ['', '']
      }, {
        title: '智能匹配',
        content: ['独创AI智慧塔多层算法智能匹配模型'],
        desc: ['智能匹配基于400万+MSDS标准数据、260万种核心档案、车源承运管理、', ' 货源类型及承运要求等形成的行业智能模型与智能算法', '适用场景:车货匹配、化工园区仓储']
      }],
      // 第二张背景图的浮动图片
      floatingImages: ['https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/新官网/首页/2@2x.png', 'https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/新官网/首页/7@2x.png', 'https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/新官网/首页/1@2x.png', 'https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/新官网/首页/6@2x.png', 'https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/新官网/首页/3@2x.png', 'https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/新官网/首页/4@2x.png', 'https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/新官网/首页/5@2x.png'],
      list1: [{
        name: '数智',
        desc: '企业内部运营和管理数字化升级，提高效率并降低成本',
        imgUrl: require("../../assets/static/img/home/new/10.png")
      }, {
        name: '互联',
        desc: '打通企业内部与外部合作方的业务数据，实现互联互通',
        imgUrl: require("../../assets/static/img/home/new/11.png")
      }, {
        name: '协同',
        desc: '企业生态对接多服务平台，参与服务生态，合作共赢',
        imgUrl: require("../../assets/static/img/home/new/12.png")
      }, {
        name: '赋能',
        desc: '实现降本增效和业务导流，孕育更有竞争力的企业服务',
        imgUrl: require("../../assets/static/img/home/new/13.png")
      }],
      addServiceList: [{
        icon: require("../../assets/static/img/home/new/14.png"),
        title: '金融服务',
        content: '针对危化品运输行业特征及企业供销存各环节经营特点和差异化需求，深度解决行业企业资金流转的问题，对接第三方银行，携手推出了服务于企业贸易采购、运费代垫的金融产品'
      }, {
        icon: require("../../assets/static/img/home/new/15.png"),
        title: '保险服务',
        content: '通过保险，深入融合各业务场景，解决货主司机在车货匹配中存在的风险和信息不对称，为全平台业务保驾护航'
      }, {
        icon: require("../../assets/static/img/home/new/16.png"),
        title: '软件服务',
        content: '危化镖局深耕行业多年，深知传统化工物流行业效率低下之顽疾，自建了一套成熟的TMS、WMS管理系统，同时还和中国联通、化工宝等企业形成战略合作，为化工园区、生产企业、物流公司提供专业化的软件定制服务'
      }, {
        icon: require("../../assets/static/img/home/new/18.png"),
        // title: '财税服务',
        // content: '为化工物流企业提供一站式完整财税解决方案，帮助企业解决经营票务上多个痛点难点，通过合理合规流程，大幅降低企业的税负成本，争取利益最大化',
        title: '镖局查车',
        content: '基于危险品车辆自身的GPS数据，无需额外硬件，只需要车牌号即可能够实时查看并保留的危化品车辆的实时位置及轨迹'
      }]
    };
  },
  watch: {
    $route: function $route(to, from) {
      if (this.$route.path.indexOf('home') >= 0) {
        if (this.$route.query.to) {
          this.goAnchor(this.getSelector());
        }
      }
    }
  },
  mounted: function mounted() {
    var _this = this;
    // 预加载背景图片
    this.preloadBackgroundImages();
    if (this.$route.query.to) {
      this.goAnchor(this.getSelector());
    }

    // 初始化 Intersection Observer 监听滚动
    this.initScrollAnimation();

    // 页面加载后先触发飞入动画，然后启动数字滚动
    this.$nextTick(function () {
      // cont-01 立即显示并触发动画
      _this.sectionAnimations.cont01 = true;
      // 延迟触发飞入动画
      setTimeout(function () {
        _this.dataBoardAnimated = true;
        // 飞入动画完成后（1秒）启动数字滚动
        setTimeout(function () {
          _this.startDataAnimation();
        }, 1000);
      }, 300);
    });
  },
  beforeDestroy: function beforeDestroy() {
    // 组件销毁时移除监听
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    // 切换到上一个 Tab
    prevTab: function prevTab() {
      if (this.activeTabIndex > 0) {
        this.activeTabIndex--;
      } else {
        // 如果是第一张，则跳到最后一张
        this.activeTabIndex = this.dataBoardTabs.length - 1;
      }
    },
    // 切换到下一个 Tab
    nextTab: function nextTab() {
      if (this.activeTabIndex < this.dataBoardTabs.length - 1) {
        this.activeTabIndex++;
      } else {
        // 如果是最后一张，则回到第一张
        this.activeTabIndex = 0;
      }
    },
    // 预加载背景图片
    preloadBackgroundImages: function preloadBackgroundImages() {
      this.backgroundImages.forEach(function (src) {
        var img = new Image();
        img.src = src;
      });
    },
    // 初始化滚动动画
    initScrollAnimation: function initScrollAnimation() {
      var _this2 = this;
      var options = {
        root: null,
        // 相对于视口
        rootMargin: '0px',
        threshold: 0.2 // 当20%的元素进入视口时触发
      };
      this.observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var target = entry.target;
            var refName = target.getAttribute('data-section');
            if (refName && _this2.sectionAnimations.hasOwnProperty(refName)) {
              _this2.sectionAnimations[refName] = true;
            }
          }
        });
      }, options);

      // 监听各个区块
      this.$nextTick(function () {
        var sections = document.querySelectorAll('.scroll-section');
        sections.forEach(function (section) {
          _this2.observer.observe(section);
        });
      });
    },
    // 格式化数字（添加千分位）
    formatNumber: function formatNumber(num) {
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    // 数字滚动动画
    animateNumber: function animateNumber(key, target) {
      var _this3 = this;
      var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2000;
      var startTime = Date.now();
      var animate = function animate() {
        var elapsed = Date.now() - startTime;
        var progress = Math.min(elapsed / duration, 1);
        // 使用缓动函数
        var easeOutQuad = progress * (2 - progress);
        _this3.dataBoard[key].value = Math.floor(target * easeOutQuad);
        if (progress < 1) {
          requestAnimationFrame(animate);
        }
      };
      requestAnimationFrame(animate);
    },
    // 启动所有数字动画
    startDataAnimation: function startDataAnimation() {
      var _this4 = this;
      var keys = Object.keys(this.dataBoard);
      keys.forEach(function (key) {
        _this4.animateNumber(key, _this4.dataBoard[key].target);
      });
    },
    // 点击左侧，切换上一张
    prevSlide: function prevSlide() {
      var length = this.middleImages.length;
      this.currentIndex = (this.currentIndex - 1 + length) % length;
    },
    // 点击右侧，切换下一张
    nextSlide: function nextSlide() {
      var length = this.middleImages.length;
      this.currentIndex = (this.currentIndex + 1) % length;
    },
    // 获取锚点
    getSelector: function getSelector() {
      var toIdName = this.$route.query.to;
      return toIdName;
    },
    // 锚点滚动
    goAnchor: function goAnchor(selector) {
      console.log('selector', selector);
      this.$refs["".concat(selector)].scrollIntoView({
        behavior: "smooth",
        // 平滑过渡
        block: "start" // start,center,end
      });
    },
    //更多服务
    moreInfo: function moreInfo() {
      this.$router.push({
        name: 'bussiness'
      });
    }
  }
};